module.exports = __webpack_public_path__ + "static/media/pin.590ac260.svg";